import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/styles/main.scss'
import { getBrandConfig } from './brand'
import setBrandConfig from './functions/setBrandConfig'
import Helpers from './functions/helpers'
import initPageAnimations from './functions/pageAnimations'
import { initTurnstile } from './functions/turnstile'
import { initTelemetry } from './functions/telemetryCollector'

const brandConfig = getBrandConfig()
store.commit('setBrandConfig', brandConfig)
store.commit('setServiceId', brandConfig.serviceIds.free)
setBrandConfig(brandConfig)

const app = createApp(App)

app.config.globalProperties.$helpers = Helpers
app.config.globalProperties.$brandConfig = brandConfig

app.use(store)
app.use(router)
app.mount('#app')

initPageAnimations(router)
initTurnstile()
initTelemetry()

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault()
  store.commit('setDefferedPrompt', e)
  store.commit('setShowAddToHomeScreen', true)
})
